<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.ageCategoryNav.overview')" link="ageCategories" />
    <item-nav-group v-if="!isEmpty(ageCategories)" :open="true" :label="$t('layout.nav.admin.ageCategoryNav.ageCategories')">
      <item-nav-group-item v-for="ageCategory in ageCategories"
                           v-if="!ageCategory.deleted"
                           :label="getName(ageCategory.name)"
                           :params="routeParams(ageCategory.id)"
                           :key="ageCategory.id"
                           link="ageCategory" />
    </item-nav-group>
    <item-nav-group v-if="!isEmpty(deletedAgeCategories)" :open="false" :label="$t('layout.nav.admin.ageCategoryNav.deletedAgeCategories')">
      <item-nav-group-item v-for="ageCategory in deletedAgeCategories"
                           :label="getName(ageCategory.name)"
                           :params="routeParams(ageCategory.id)"
                           :key="ageCategory.id"
                           link="ageCategory" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';

export default {
  name: 'AgeCategoryNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      ageCategories: [],
    };
  },

  computed: {
    deletedAgeCategories: function () {
      return this.ageCategories.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.axios.get(this.serviceUrls.ageCategory.list(this))
      .then((response) => {
        this.ageCategories = sortBy(response.data.data, ['ageFrom', `name.${this.hotelSettings.details.primaryLanguage}`]);
      });

    this.$serviceBus.$on('ageCategory.list', (data) => {
      if (isNil(data)) {
        this.axios.get(this.serviceUrls.ageCategory.list(this))
          .then((response) => {
            this.ageCategories = sortBy(response.data.data, ['ageFrom', `name.${this.hotelSettings.details.primaryLanguage}`]);
          });
      } else {
        this.ageCategories = data;
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(ageCategoryId) {
      return {
        ageCategoryId: ageCategoryId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/AgeCategoryNav.vue